import dynaForms from '@elab/core/utils/dynaForms';

export const storeName = 'phone-verification_for-registration-form';

export default {
    ...dynaForms.getTypes(storeName),
    START_VERIFICATION: `${storeName}.START_VERIFICATION`,
    SET_TIMEOUT: `${storeName}.SET_TIMEOUT`,
    SUCCESS_VERIFIED: `${storeName}.SUCCESS_VERIFIED`,
    EDIT_PHONE: `${storeName}.EDIT_PHONE`,
    RESTART_VERIFICATION: `${storeName}.RESTART_VERIFICATION`,
    ERROR_VERIFICATION: `${storeName}.ERROR_VERIFICATION`,
    CODE_EXPIRED: `${storeName}.CODE_EXPIRED`,
    SET_VERIFICATION_STATE: `${storeName}.SET_VERIFICATION_STATE`,
    COMPLETE_VERIFICATION: `${storeName}.COMPLETE_VERIFICATION`,
    CHANGE_IS_RETRY_DISABLED: `${storeName}.CHANGE_IS_RETRY_DISABLED`,
    PHONE_VERIFICATION_CLOSE: `${storeName}.PHONE_VERIFICATION_CLOSE`,
    SHOW_PHONE_VERIFICATION_FIELD: `${storeName}.SHOW_PHONE_VERIFICATION_FIELD`,
    RESET_FORM: `${storeName}.RESET_FORM`,
};
